import { SortDefinition, SortOrderBy } from '@anecdotes/design-system/data-manipulation';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { TrustCenterFacadeService, UserResponse } from '@anecdotes/shared-trust-center';
import { TrustCenterModalService } from '../../../../services/trustcenter-modals/trustcenter-modals.service';
import { sortAlphabetically } from '@anecdotes/utils';

@Component({
  selector: 'app-access-manager-renderer',
  templateUrl: './access-manager-renderer.component.html',
  styleUrls: ['./access-manager-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessManagerRendererComponent implements OnInit {
  readonly startOrderBy = SortOrderBy.DESC;
  readonly sortDefinitions: SortDefinition<UserResponse>[] = [
    {
      id: 'fullName',
      translationKey: this.buildTranslationKey('users.fullName'),
      propertySelector: (user) => `${user.first_name} ${user.last_name}`,
      sortFunc: sortAlphabetically,
    },
    {
      id: 'title',
      translationKey: this.buildTranslationKey('users.jobTitle'),
      propertySelector: (user) => user.job_title,
    },
    {
      id: 'company',
      translationKey: this.buildTranslationKey('users.companyName'),
      propertySelector: (user) => user.company,
    },
    {
      id: 'email',
      translationKey: this.buildTranslationKey('users.workEmail'),
      propertySelector: (user) => user.email,
    },
    {
      id: 'approvalType',
      translationKey: this.buildTranslationKey('users.approvalType'),
      propertySelector: (user) => user.created_source,
    },
    {
      id: 'status',
      translationKey: this.buildTranslationKey('users.status'),
      propertySelector: (user) => user.status,
    },
    {
      id: 'profile',
      translationKey: this.buildTranslationKey('users.profile'),
      propertySelector: (user) => user.permission_profile,
    },
    {
      id: 'lastLoginTime',
      translationKey: this.buildTranslationKey('users.lastLoginTime'),
      propertySelector: (user) => user.last_login || '',
    },
    { id: 'actions' },
  ];

  @Input()
  allUsersWithAccess: UserResponse[];

  sortedData$ = new BehaviorSubject<UserResponse[]>([]);
  hasUsers$: Observable<boolean>;

  constructor(
    private trustCenterFacadeService: TrustCenterFacadeService,
    private trustCenterModalService: TrustCenterModalService,
  ) {}

  ngOnInit(): void {
    this.hasUsers$ = this.trustCenterFacadeService.getNonNewUserRequests().pipe(map((users) => !!users.length));
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  idSelector(item: UserResponse): string {
    return item.email;
  }

  openInviteModal(): void {
    this.trustCenterModalService.openInviteUserModal();
  }

  handleSort(sorted: UserResponse[]): void {
    this.sortedData$.next(sorted);
  }
}
